import "./module-brand.css";
import { MODULE_LOGO_PATH } from "./module-branding";

export type BrandMarkLayout = "inline" | "stacked";

export interface ModuleBrandLogoProps {
  /** Nom commercial affiché à côté du logo (ex. ITaaS RH). */
  name: string;
  tagline?: string;
  src?: string;
  /** Logo compact — masque le texte sauf si showName est forcé. */
  small?: boolean;
  /** Affiche le nom commercial à côté du picto (défaut : true sauf small). */
  showName?: boolean;
  layout?: BrandMarkLayout;
  className?: string;
}

/** Logo module + nom commercial — pictos standalone core/logos. */
export function ModuleBrandLogo({
  name,
  tagline,
  src = `/${MODULE_LOGO_PATH}`,
  small = false,
  showName,
  layout = "inline",
  className,
}: ModuleBrandLogoProps) {
  const displayName = showName ?? !small;

  return (
    <div
      className={[
        "itaas-module-brand",
        small ? "itaas-module-brand--small" : "",
        layout === "stacked" ? "itaas-module-brand--stacked" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="itaas-module-brand__row">
        <img
          src={src}
          alt=""
          role="presentation"
          className="itaas-module-brand__img"
          decoding="async"
        />
        {displayName ? (
          <span className="itaas-module-brand__name">{name}</span>
        ) : (
          <span className="visually-hidden">{name}</span>
        )}
      </div>
      {tagline ? <div className="itaas-module-brand__tagline">{tagline}</div> : null}
    </div>
  );
}
